import React from 'react'
import { Award, TrendingUp, Users, AlertTriangle, Clock, XCircle } from 'lucide-react'

interface PerformanceLevelBadgeProps {
  level: string
  score: number
  size?: 'sm' | 'md' | 'lg'
  showIcon?: boolean
}

const PerformanceLevelBadge = ({ 
  level, 
  score, 
  size = 'md', 
  showIcon = true 
}: PerformanceLevelBadgeProps) => {
  
  const getPerformanceConfig = () => {
    if (score >= 90) {
      return {
        bgColor: 'bg-success/20 border-success/30',
        textColor: 'text-success',
        icon: Award,
        label: 'Alta Performance'
      }
    } else if (score >= 80) {
      return {
        bgColor: 'bg-brand-primary/20 border-brand-primary/30',
        textColor: 'text-brand-primary',
        icon: TrendingUp,
        label: 'Potencial'
      }
    } else if (score >= 70) {
      return {
        bgColor: 'bg-brand-blue/20 border-brand-blue/30',
        textColor: 'text-brand-blue',
        icon: Users,
        label: 'Crescimento'
      }
    } else if (score >= 60) {
      return {
        bgColor: 'bg-info/20 border-info/30',
        textColor: 'text-info',
        icon: Clock,
        label: 'Cumpre Função'
      }
    } else if (score >= 40) {
      return {
        bgColor: 'bg-warning/20 border-warning/30',
        textColor: 'text-warning',
        icon: AlertTriangle,
        label: 'Sob Análise'
      }
    } else {
      return {
        bgColor: 'bg-error/20 border-error/30',
        textColor: 'text-error',
        icon: XCircle,
        label: 'Desalinhado'
      }
    }
  }

  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return {
          container: 'px-2 py-1 text-xs',
          icon: 12
        }
      case 'lg':
        return {
          container: 'px-6 py-3 text-lg',
          icon: 20
        }
      default:
        return {
          container: 'px-4 py-2 text-sm',
          icon: 16
        }
    }
  }

  const config = getPerformanceConfig()
  const sizeClasses = getSizeClasses()
  const Icon = config.icon

  return (
    <div className={`
      inline-flex items-center space-x-2 rounded-full border font-display font-semibold
      transition-all duration-200 hover:scale-105
      ${config.bgColor} ${config.textColor} ${sizeClasses.container}
    `}>
      {showIcon && <Icon size={sizeClasses.icon} />}
      <span>{level || config.label}</span>
    </div>
  )
}

export default PerformanceLevelBadge
